import {DrawFrmApp} from "../drawfrm/DrawFrmApp";
import {Alert} from "@mui/material";
import {ManagedScene} from "../drawfrm/Scene";

export class ErrorScene extends ManagedScene {
    error: string;

    constructor(error: any) {
        super();
        this.error = error instanceof Error ? error.message : String(error);
    }

    setup(app: DrawFrmApp): void {
        super.setup(app);

        const err = this.error;

        this.showReact({
            render: () => {
                return (<Alert severity="error">
                    {err}
                </Alert>)
            }
        })
    }

}